import { type FC } from 'react';

import MuiAccordion, { type AccordionProps } from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { Icon } from '@vakantiesnl/components/src/atoms/Icon';
import { Typography } from '@vakantiesnl/components/src/atoms/Typography';

import { useAccordionSummaryStyles, useAccordionDetailsStyles, useAccordionStyles } from './Accordion.style';

type Props = AccordionProps & {
	label: string;
};

export const Accordion: FC<Props> = ({ label, children, defaultExpanded }) => {
	const { classes: accordionDetailsClasses } = useAccordionDetailsStyles();
	const { classes: accordionClasses } = useAccordionStyles();
	const { classes: accordionSummaryClasses } = useAccordionSummaryStyles();

	return (
		<>
			<MuiAccordion defaultExpanded={defaultExpanded} square={true} classes={accordionClasses}>
				<MuiAccordionSummary
					expandIcon={<Icon type="chevronDown" />}
					aria-controls={`${label}-content`}
					id={`${label}-content`}
					classes={accordionSummaryClasses}
				>
					<Typography as="h3" variant="headingXs">
						{label}
					</Typography>
				</MuiAccordionSummary>
				<AccordionDetails classes={accordionDetailsClasses}>{children}</AccordionDetails>
			</MuiAccordion>
		</>
	);
};
